import * as React from "react";
import { Modal, Form, Button } from "antd";
import CopyFormTypeForm, { CopyFormTypeFormProps } from "./CopyFormTypeForm";

export interface State {}

export interface Props {
  copyFormModalVisible?: boolean;
  hideCopyFormModal: any;
  translate: any;
  rowData: any;
  copyFormType: any;
}

export default class FormTypeCopyDialog extends React.Component<Props, State> {
  private formSubmitHandler: any;

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.registerFormSubmitEventHandler = this.registerFormSubmitEventHandler.bind(
      this
    );
  }

  registerFormSubmitEventHandler(registrationHandler) {
    this.formSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const { copyFormType, hideCopyFormModal } = this.props;
    if (this.formSubmitHandler) {
      let newData = this.formSubmitHandler(e);
      if (newData) {
        copyFormType(newData.oldCode, newData);
        hideCopyFormModal();
      }
    }
  }

  render() {
    const {
      copyFormModalVisible,
      hideCopyFormModal,
      translate,
      rowData,
      copyFormType
    } = this.props;

    const FormTypeCopy = Form.create<CopyFormTypeFormProps>({})(
      CopyFormTypeForm
    );

    return (
      <Modal
        title={translate("formType_form.copy_modal_title")}
        maskClosable={false}
        visible={copyFormModalVisible}
        onCancel={hideCopyFormModal}
        onOk={this.onSubmit}
        footer={[
          <Button key="back" onClick={hideCopyFormModal}>
            {translate("modal_functions.copy_modal.cancel")}
          </Button>,
          <Button key="submit" type="danger" onClick={this.onSubmit}>
            {translate("modal_functions.copy_modal.copy")}
          </Button>
        ]}
      >
        <FormTypeCopy
          translate={translate}
          rowData={rowData}
          copyFormType={copyFormType}
          registerFormSubmitEventHandler={this.registerFormSubmitEventHandler}
        ></FormTypeCopy>
      </Modal>
    );
  }
}
